module.exports = __webpack_public_path__ + "static/media/member-logo1.2a0af193.jpg";